import { styled } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import { forwardRef } from "react";

const Container = styled("div")({
  position: "relative",
  width: "100%",
  borderRadius: 8,
  overflow: "hidden",
  backgroundColor: "#000",
  aspectRatio: "4 / 3",
});

const StyledVideo = styled("video")({
  width: "100%",
  height: "100%",
  objectFit: "cover",
  display: "block",
});

const CameraPreview = forwardRef(
  ({ mirror, ariaLabel, children, ...rest }, ref) => (
    <Container>
      <StyledVideo
        ref={ref}
        autoPlay
        playsInline
        style={mirror ? { transform: "scaleX(-1)" } : undefined}
        aria-label={ariaLabel}
        {...rest}
      />
      {children}
    </Container>
  ),
);

CameraPreview.displayName = "CameraPreview";

CameraPreview.propTypes = {
  mirror: PropTypes.bool,
  ariaLabel: PropTypes.string,
  children: PropTypes.node,
};

export default CameraPreview;
